/* global axios */
import ApiClient from './ApiClient';

class ConclusionsAPI extends ApiClient {
  constructor() {
    super('conclusions', { accountScoped: true });
  }

  get({ page, from, to, agents, channels, conversation_id }) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        agents,
        channels,
        conversation_id,
      },
    });
  }

  batch({ ids, remark, status }) {
    return axios.post(`${this.url}/batch`, { ids, remark, status });
  }

  pop_data({ page, phone }) {
    return axios.post(`${this.url}/pop_data`, { page, phone });
  }
}

export default new ConclusionsAPI();
